import { appStore } from '../stores/appStore';
import { get } from 'svelte/store';
// Helper function to format timestamp to relative time
function formatRelativeTime(timestamp) {
    if (!timestamp)
        return 'just now';
    const now = Date.now();
    const activityTime = Number(timestamp.seconds) * 1000;
    const diff = now - activityTime;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);
    if (minutes < 1)
        return 'just now';
    if (minutes === 1)
        return '1 minute ago';
    if (minutes < 60)
        return `${minutes} minutes ago`;
    if (hours === 1)
        return '1 hour ago';
    if (hours < 24)
        return `${hours} hours ago`;
    if (days === 1)
        return '1 day ago';
    return `${days} days ago`;
}
// Helper function to parse metadata
function parseMetadata(metadataStr) {
    try {
        return JSON.parse(metadataStr);
    }
    catch {
        return {};
    }
}
// Fetch user activities
export async function getUserActivities(limit = 20) {
    const state = get(appStore);
    if (!state.client || !state.token) {
        console.warn('ActivityFeed: No client or token available', {
            hasClient: !!state.client,
            hasToken: !!state.token
        });
        return [];
    }
    try {
        console.log('Fetching user activities with limit:', limit);
        const result = await state.client.getUserActivities({
            token: state.token,
            userId: '', // Empty means current user
            limit,
        });
        console.log('getUserActivities response:', {
            successFull: result.response.successFull,
            status: result.response.status,
            reason: result.response.reason,
            activityCount: result.response.activities?.length || 0
        });
        if (result.response.successFull && result.response.activities) {
            const activities = result.response.activities.map((activity) => {
                const metadata = parseMetadata(activity.metadata || '{}');
                return {
                    id: activity.id,
                    type: activity.activityType,
                    repo: activity.repositoryName || '',
                    repoId: activity.repositoryId,
                    message: activity.message,
                    user: activity.userName,
                    userId: activity.userId,
                    userAvatarUrl: activity.userAvatarUrl,
                    time: formatRelativeTime(activity.createdAt),
                    icon: metadata.icon || '📌',
                    status: metadata.status,
                };
            });
            console.log('Parsed activities:', activities);
            return activities;
        }
        console.warn('No activities returned or request failed:', result.response);
        return [];
    }
    catch (error) {
        console.error('Error fetching user activities:', error);
        return [];
    }
}
// Fetch activities from followed users
export async function getFollowingActivities(limit = 20) {
    const state = get(appStore);
    if (!state.client || !state.token) {
        return [];
    }
    try {
        const result = await state.client.getFollowingActivities({
            token: state.token,
            limit,
        });
        if (result.response.successFull && result.response.activities) {
            return result.response.activities.map((activity) => {
                const metadata = parseMetadata(activity.metadata || '{}');
                return {
                    id: activity.id,
                    type: activity.activityType,
                    repo: activity.repositoryName || '',
                    repoId: activity.repositoryId,
                    message: activity.message,
                    user: activity.userName,
                    userId: activity.userId,
                    userAvatarUrl: activity.userAvatarUrl,
                    time: formatRelativeTime(activity.createdAt),
                    icon: metadata.icon || '📌',
                    status: metadata.status,
                };
            });
        }
        return [];
    }
    catch (error) {
        console.error('Error fetching following activities:', error);
        return [];
    }
}
// Fetch repository activities
export async function getRepositoryActivities(repositoryId, limit = 20) {
    const state = get(appStore);
    if (!state.client || !state.token) {
        return [];
    }
    try {
        const result = await state.client.getRepositoryActivities({
            token: state.token,
            repositoryId,
            limit,
        });
        if (result.response.successFull && result.response.activities) {
            return result.response.activities.map((activity) => {
                const metadata = parseMetadata(activity.metadata || '{}');
                return {
                    id: activity.id,
                    type: activity.activityType,
                    repo: activity.repositoryName || '',
                    repoId: activity.repositoryId,
                    message: activity.message,
                    user: activity.userName,
                    userId: activity.userId,
                    userAvatarUrl: activity.userAvatarUrl,
                    time: formatRelativeTime(activity.createdAt),
                    icon: metadata.icon || '📌',
                    status: metadata.status,
                };
            });
        }
        return [];
    }
    catch (error) {
        console.error('Error fetching repository activities:', error);
        return [];
    }
}
